import {
  HttpErrorResponse,
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest
} from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable, catchError, map, throwError } from 'rxjs';
import { AuthService } from 'src/app/auth/services/auth.service';
import { MessageType } from 'src/app/shared/models/message-type.enum';
import { NotificationService } from './notification.service';

@Injectable()
export class AppInterceptor implements HttpInterceptor {

  private authService = inject(AuthService);
  private notification = inject(NotificationService);

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    const token = this.authService.getAccessToken();
    const modifiedRequest = request.clone({
      headers: request.headers.append('Authorization', token),
    });
    return next.handle(modifiedRequest).pipe(
      catchError((x) =>this.handleError(x)),
      map((response) => response)
  );
  }

  private handleError(err: HttpErrorResponse): Observable<any> {
    let errorResponse = {
      status: false,
      message: "Something went wrong",
      data: null,
      statusCode: 500
    }
    switch (err.status) {
      case 401:
        errorResponse = this.handleUnauthorizedError();
        break;
      case 0:
        errorResponse = this.handleNetworkError();
        break;
      default:
        errorResponse = this.handleGenericError(err);
    }

    // Make sure we return a valid observable if error is not caught upstream
    return throwError(()=> errorResponse);
  }

  private handleUnauthorizedError() {
    const msg = "Access denied! Contact admin";
    this.notification.notify(msg, MessageType.ERROR);
    return {
      status: false,
      message: msg,
      data: null,
      statusCode: 401
    };
  }

  private handleNetworkError() {
    const msg = "Network issue, Unable to proceed";
    //this.notification.notify(msg, MessageType.ERROR);
    return{
      status: false,
      message: msg,
      data: null,
      statusCode: 0
    };
  }

  private handleGenericError(err: HttpErrorResponse){
    const msg = err.error?.message || "Something went wrong!";
    this.notification.notify(msg, MessageType.ERROR);
    return {
      status: false,
      message: msg,
      data: null,
      statusCode: 500
    };
  }

}
